import React, { useEffect, useRef } from "react"
import { animated, interpolate } from "react-spring"


const computeVisiblePercentage = (top, bottom, vh) => {
  return interpolate([top, bottom], (top, bottom) => {
    if (bottom > vh || top > vh) {
      return 0
    }
    // vertical scrolling
    if (top < 0) {
      // I'm exiting
      return (vh - bottom) / vh
    } else {
      return (vh - top) / vh
    }

  })
}

const computeShadow = (top, bottom, vh) => {
  return interpolate([top, bottom], (top, bottom) => {
    if (top > 0 && top < vh) {
      return 1 - (vh - top) / vh
    }
    return 0
  })
}

const AnimatorMobileInner = ({ top, bottom, vh, planarTop, planarBottom, zIndex, innerRef, children, urls, ...props }) => {
  const openPercent = computeVisiblePercentage(
    planarTop,
    planarBottom,
    vh
  )

  const me = useRef(null)

  useEffect(() => {
    const domElement = (innerRef && innerRef.current) || (me && me.current)
    if (props.snapTo) {
      if (domElement && props.snapTo === "end") {
        domElement.scrollTop = domElement.scrollHeight
      } else {
        domElement.scrollTop = 0
      }
    }
  }, [innerRef, props.snapTo])

  useEffect(() => {
    if (innerRef !== undefined && props.scrollTo) {
      const idx = urls.findIndex(url => url === props.scrollTo)
      if (idx > -1) {
        innerRef.current.children.item(idx).scrollIntoView()
      }
    }
  })

  return (
    <>
      <animated.div
        style={{
          position: "absolute",
          backgroundColor: "#000",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          opacity: computeShadow(
            planarTop,
            planarBottom,
            vh
          ),
          zIndex: zIndex + 1,
          pointerEvents: "none",
          borderRadius: 18,
        }}
      ></animated.div>
      <animated.div
        className="page"
        style={{
          position: "absolute",
          top: 0,
          bottom: bottom,
          left: 0,
          right: 0,
          zIndex,
          borderRadius: "inherit",
        }}
      >
        <animated.div ref={innerRef || me} style={{
          position: "absolute",
          top: top,
          bottom: 0,
          left: 0,
          right: 0,
          overflowY: "scroll",
          borderRadius: "inherit"
        }}>
          {/* <div style={{ height: 10, background: "green" }}></div> */}
          {children.map((Child, i) => <Child key={i} openPercent={openPercent} />)}
          {/* <div style={{ height: 10, background: "green" }}></div> */}
        </animated.div>

      </animated.div>
    </>
  )
}

const AnimatorMobile = (elements, urls) => props => <AnimatorMobileInner {...props} urls={urls}>{elements}</AnimatorMobileInner>

export default AnimatorMobile
